(function () {
  var ctx = document.getElementById('sp-rv26-ctx');
  if (!ctx || !window.MutationObserver) return;
  var PID = ctx.dataset.pid;
  var KIND = ctx.dataset.kind || 'item';
  var EYEBROW = ctx.dataset.eyebrow || '';
  var COMPANY = (function () {
    var s = document.querySelector('script[src*="company_id="]');
    var m = s && s.src.match(/company_id=([A-Za-z0-9]+)/);
    return m ? m[1] : 'RwSTEA';
  })();
  var API = 'https://fast.a.klaviyo.com/reviews/api/client_reviews/' + PID + '/?product_id=' + PID +
    '&company_id=' + COMPANY + '&sort=0&filter=&type=reviews';
  var TYPE = (ctx.dataset.type || '').toLowerCase();
  var TITLE = (ctx.dataset.title || '').toLowerCase();
  var VENDOR = (ctx.dataset.vendor || '').replace(/\.+$/, '').trim();
  if (/^simple paper/i.test(VENDOR) || /,|\bco\b|ltd/i.test(VENDOR)) VENDOR = '';
  function family() {
    if (KIND !== 'item') return KIND;
    var t = TYPE || TITLE;
    var has = function (re) { return re.test(t); };
    if (has(/journaling card/)) return 'card';
    if (has(/washi|pet tape|masking/)) return 'washi';
    if (has(/stamp/)) return 'stamp';
    if (has(/sticky note|memo|notepad/)) return 'notes';
    if (has(/pouch|pen case|tool box|folder|binder|tote|pen holder|notebook cover|tn accessor|bag/)) return 'carry';
    if (has(/sharpener|dispenser/)) return 'tool';
    if (has(/\bpens?\b|pencil|highlighter|marker|\bink\b|refill|converter|brush/)) return 'pen';
    if (has(/notebook|planner|journal|calendar|diary|refill paper|loose leaf/)) return 'notebook';
    if (has(/scissor|cutter|ruler|stapler|punch|dispenser|clip|correction|glue|adhesive|eraser|calculator|tape/)) return 'tool';
    return 'item';
  }
  var FAM = family();
  var NOUN = { washi: 'washi tape', stamp: 'stamp', notes: 'sticky notes', pen: 'pen', notebook: 'notebook',
    card: 'journaling card', carry: 'case', tool: 'tool', item: 'piece' }[FAM];
  if (/^(carry|tool|pen|notebook|stamp|notes)$/.test(FAM) && /^[a-z' ]{3,24}$/.test(TYPE) && !/^(pens|stamps|notebook|stickers)$/.test(TYPE)) NOUN = TYPE;
  if (FAM === 'pen' && /pens$/.test(NOUN)) NOUN = NOUN.replace(/pens$/, 'pen');
  if (FAM === 'pen' && /pencils$/.test(NOUN)) NOUN = NOUN.replace(/pencils$/, 'pencil');
  if (/accessor/.test(NOUN)) NOUN = 'accessory';
  var PLURAL = /(notes|scissors|clips|colors|pads|markers)$/.test(NOUN);
  var IT = (PLURAL ? 'these ' : 'this ') + (VENDOR ? (new RegExp('\\b' + NOUN + '$', 'i').test(VENDOR) ? VENDOR : VENDOR + ' ' + NOUN) : NOUN);
  function v(one, many) { return PLURAL ? many : one; }
  var COPY = {
    kit: { prompt: 'Have this kit?', share: 'We love seeing where these stickers end up.',
      title: 'A little note from your desk',
      empty: 'Tell other journalers how this kit came together in your planner.',
      tips: ['How the sticker paper feels and peels', 'Your favorite sheet in the kit', 'Where it went: planner, journal or scrapbook'] },
    sticker: { prompt: 'Have these stickers?', share: 'We love seeing where these stickers end up.',
      title: 'Be the first to share your stickers',
      empty: 'Tell other journalers how these stickers looked on your pages.',
      tips: ['How the sticker paper feels and peels', 'Your favorite design on the sheet', 'Where they went: planner, journal or scrapbook'] },
    washi: { prompt: 'Have this tape?', share: 'We love seeing what you decorate. Share a spread with this tape.',
      title: 'Be the first to share your tape',
      empty: 'Tell other journalers how you decorated with ' + IT + '.',
      tips: ['How easily it tears and repositions', 'The colors and patterns you love', 'What you dressed with it: spreads, letters or gifts'] },
    stamp: { prompt: 'Have this stamp?', share: 'We love seeing what you stamp. Share a print from your pages.',
      title: 'Be the first to share your prints',
      empty: 'Tell other journalers what you made with ' + IT + '.',
      tips: ['How crisp and lovely the prints come out', 'Your favorite ink or pad to pair it with', 'Where you stamped it'] },
    pen: { prompt: 'Have this one?', share: 'We love seeing your handwriting. Share a page you wrote with it.',
      title: 'Be the first to share what you love',
      empty: 'Tell other journalers what you love about writing with ' + IT + '.',
      tips: ['How smooth the line feels', 'The colors you reach for most', 'Your favorite paper to pair it with'] },
    notebook: { prompt: 'Have this one?', share: 'We love seeing filled pages. Share a spread from yours.',
      title: 'Be the first to share your pages',
      empty: 'Tell other journalers how ' + IT + ' ' + v('fits', 'fit') + ' into your days.',
      tips: ['How the paper feels with your favorite pens', 'How nicely it opens and lies flat', 'What it holds: plans, journaling or notes'] },
    notes: { prompt: 'Have these?', share: 'We love seeing how you use them. Share a photo from your desk.',
      title: 'Be the first to share your notes',
      empty: 'Tell other journalers how you use ' + IT + '.',
      tips: ['How nicely they stick and lift', 'How lovely the paper is to write on', 'Where they live: desk, planner or books'] },
    card: { prompt: 'Have this card?', share: 'We love seeing finished spreads. Share yours with this card.',
      title: 'Be the first to share your card',
      empty: 'Tell other journalers how this card finished your spread.',
      tips: ['How the finish looks up close', 'Which spread or kit you paired it with', 'Where it went: planner, journal or scrapbook'] },
    carry: { prompt: 'Have this one?', share: 'We love seeing what you carry. Share a photo of yours packed.',
      title: 'Be the first to show how you carry it',
      empty: 'Tell other journalers what you keep in ' + IT + ' and where it goes with you.',
      tips: ['Your favorite things to keep inside', 'How it fits your daily routine', 'Where it goes: desk, bag or travels'] },
    tool: { prompt: 'Have this one?', share: 'We love seeing your desk setup. Share a photo of it in use.',
      title: 'Be the first to share a favorite',
      empty: 'Tell other journalers what you love about ' + IT + '.',
      tips: ['How it feels in the hand', 'What you use it for most', 'What makes it a desk favorite'] },
    item: { prompt: 'Have this one?', share: 'We love seeing it in use. Share a photo from your pages.',
      title: 'Be the first to share your pages',
      empty: 'Tell other journalers what you love about ' + IT + '.',
      tips: ['How it feels to use', 'What you made with it', 'Where it went: planner, journal or scrapbook'] }
  }[FAM] || null;
  var TOPICS = [['Floral designs', 'floral'], ['Washi paper', 'washi'], ['Quality', 'quality'], ['Value', 'value'],
    ['Planner pages', 'planner'], ['Journaling', 'journal'], ['Colors', 'color'], ['Themes', 'theme'],
    ['Artwork', 'art'], ['Worth it', 'worth'], ['Packaging', 'packag'], ['Shipping', 'shipping'],
    ['Variety', 'variety'], ['Easy to peel', 'peel'], ['Gifts', 'gift'], ['Smooth writing', 'smooth'], ['Ink', 'ink']];

  var data = { hist: null, total: null, photos: null, topics: null, filtered: null };
  var root = null;

  function q(sel, el) { return (el || root).querySelector(sel); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  var TILE_ZOOM = 1.06;
  function sharpTile(t) {
    var img = t.querySelector('img');
    if (!img) return;
    var w = t.getBoundingClientRect().width;
    if (!w) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var src = img.getAttribute('src') || '';
    if (/\/width:\d+\/height:\d+\/resizing_type:fill\//.test(src)) {
      var want = Math.min(520, Math.max(260, Math.ceil(w * dpr * 1.12 / 40) * 40));
      var next = src.replace(/\/width:\d+\/height:\d+\//, '/width:' + want + '/height:' + want + '/');
      if (next !== src) img.setAttribute('src', next);
    }
    var check = function () {
      var ok = img.naturalWidth >= w * dpr * TILE_ZOOM && img.naturalHeight >= w * dpr * TILE_ZOOM;
      if (ok !== t.hasAttribute('data-sp-zoom')) t.toggleAttribute('data-sp-zoom', ok);
    };
    if (img.complete && img.naturalWidth) check(); else img.addEventListener('load', check, { once: true });
  }

  function setAttr(e, k, v) { if (e && e.getAttribute(k) !== String(v)) e.setAttribute(k, v); }
  function vendorWrite() { return q('.kl_reviews__button_bar .kl_reviews__button'); }
  function clickWrite() { var b = vendorWrite(); if (b) b.click(); }
  var ARROW = '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" aria-hidden="true"><path d="M6 3.5 10.5 8 6 12.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function xhr(url, cb) {
    var r = new XMLHttpRequest();
    r.open('GET', url);
    r.onload = function () { try { cb(JSON.parse(r.responseText)); } catch (e) { cb(null); } };
    r.onerror = function () { cb(null); };
    r.send();
  }

  function load() {
    xhr(API + '&limit=50&offset=0&media=false', function (a) {
      if (!a) return;
      var p = a.product || a.summary || {};
      if (p.rating_histogram) data.hist = p.rating_histogram;
      if (typeof p.review_count === 'number') data.total = p.review_count;
      var texts = (a.reviews || []).map(function (r) { return (r.content || '') + ' ' + (r.title || ''); });
      var done = function () { data.topics = topics(texts); schedule(); };
      if (a.has_more) xhr(API + '&limit=50&offset=50&media=false', function (b) {
        (b && b.reviews || []).forEach(function (r) { texts.push((r.content || '') + ' ' + (r.title || '')); });
        done();
      }); else done();
    });
    xhr(API + '&limit=50&offset=0&media=true', function (m) {
      if (!m) return;
      var n = 0;
      (m.reviews || []).forEach(function (r) {
        var u = r.image_uuid;
        n += Array.isArray(u) ? u.length : (u ? String(u).split(',').filter(Boolean).length : 0);
        n += (r.videos || []).length;
      });
      data.photos = m.has_more ? null : n;
      schedule();
    });
  }

  function topics(texts) {
    if (texts.length < 5) return [];
    var low = texts.map(function (t) { return t.toLowerCase(); });
    return TOPICS.map(function (t) {
      var re = new RegExp('\\b' + t[1]);
      return { label: t[0], term: t[1], n: low.filter(function (s) { return re.test(s); }).length };
    }).filter(function (t) { return t.n >= 3; }).sort(function (a, b) { return b.n - a.n; }).slice(0, 5);
  }
  (function tap() {
    if (!window.fetch) return;
    var prev = window.fetch;
    window.fetch = function (input, init) {
      var p = prev.apply(this, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/reviews\/api\/client_reviews\/\d+\/\?/.test(url) && /type=reviews/.test(url)) {
        p.then(function (res) {
          res.clone().json().then(function (j) {
            if (j && typeof j.filtered_count === 'number') { data.filtered = j.filtered_count; schedule(); }
          }).catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  })();

  function isEmpty() {
    var c = q('.kl_reviews__summary__stars__count');
    if (data.total === 0) return true;
    return !!(c && /^\s*0\b/.test(c.textContent) && q('.kl_reviews__list_empty_state'));
  }

  function ensure() {
    root = document.querySelector('[id*="klaviyo_reviews_product_reviews"] .reviews_all_container');
    if (!root) return;
    var summary = q('.kl_reviews__summary');
    if (!summary) return;
    var empty = isEmpty();
    root.classList.toggle('sp-rv-empty', empty);
    var h2 = q('.kl_reviews__summary__header');
    if (h2 && EYEBROW && !q('.sp-rv-eyebrow')) h2.parentNode.insertBefore(el('p', 'sp-rv-eyebrow', EYEBROW), h2);

    if (empty) { ensureEmpty(summary); return; }
    var stars = q('.kl_reviews__summary__average_and_stars');
    if (stars && !q('.sp-rv-write', stars)) {
      var w = el('button', 'sp-rv-write', 'Write a review');
      w.type = 'button';
      w.addEventListener('click', clickWrite);
      stars.appendChild(w);
    }
    var rows = root.querySelectorAll('.kl_reviews__histogram__row');
    rows.forEach(function (row) {
      var star = parseInt((q('.kl_reviews__histogram__rating', row) || {}).textContent, 10);
      var v = q('.kl_reviews__histogram__value', row);
      if (!v || !star) return;
      var zero;
      if (data.hist) {
        var n = data.hist[star - 1] || 0;
        setAttr(v, 'data-sp-n', n);
        zero = n === 0;
      } else {
        zero = /^\s*0\s*%/.test(v.textContent);
      }
      row.classList.toggle('sp-rv-zero', zero);
      if (zero && row.getAttribute('aria-disabled') !== 'true') {
        row.setAttribute('data-sp-tab', row.getAttribute('tabindex') || '');
        row.setAttribute('aria-disabled', 'true'); row.setAttribute('tabindex', '-1');
      } else if (!zero && row.hasAttribute('data-sp-tab')) {
        var t = row.getAttribute('data-sp-tab');
        if (t) row.setAttribute('tabindex', t); else row.removeAttribute('tabindex');
        row.removeAttribute('aria-disabled'); row.removeAttribute('data-sp-tab');
      }
    });
    var grid = q('.kl_reviews__summary__image_grid');
    if (grid) {
      var head = q('.sp-rv-photos-head', grid);
      if (!head) {
        head = el('div', 'sp-rv-photos-head');
        head.appendChild(el('p', 'sp-rv-label', 'Customer photos'));
        var va = el('button', 'sp-rv-viewall');
        va.type = 'button';
        va.innerHTML = '<span></span>' + ARROW;
        va.addEventListener('click', function () {
          var m = q('.kl_reviews__filters__pill button[role="checkbox"]');
          if (m && m.getAttribute('aria-checked') !== 'true') m.click();
          var t = q('.kl_reviews__list__tab_buttons') || q('.kl_reviews__list');
          if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        head.appendChild(va);
        grid.insertBefore(head, grid.firstChild);
      }
      var label = data.photos ? 'View all ' + data.photos : 'View all';
      var span = q('.sp-rv-viewall span', head);
      if (span && span.textContent !== label) span.textContent = label;
      var tiles = grid.querySelectorAll('.kl_reviews__summary_image');
      tiles.forEach(function (t, i) {
        var more = (i === 5 && data.photos && data.photos > 6) ? '+' + (data.photos - 6) : '';
        if (more) setAttr(t, 'data-sp-more', more); else if (t.hasAttribute('data-sp-more')) t.removeAttribute('data-sp-more');
        sharpTile(t);
      });
    }
    root.querySelectorAll('svg').forEach(function (s) {
      if (!s.querySelector('clipPath[id^="onsite-shop-syndication-badge"]') || s.hasAttribute('data-sp-shop')) return;
      s.setAttribute('data-sp-shop', '');
      s.setAttribute('aria-hidden', 'true');
      // Designer note 10/27 ("update verified on shop to this", Figma 3720:15589): "Verified on" plus the shop
      // wordmark in Shop's purple, no pill. The wordmark paths are the designer's own export.
      var lab = el('span', 'sp-rv-shop-verified');
      lab.innerHTML = 'Verified on <svg class="sp-rv-shop-verified__mark" viewBox="86.8 322.9 31.6 13.2" aria-label="Shop" role="img" focusable="false" fill="currentColor"><path d="M90.6921 328.861C89.4463 328.59 88.8913 328.485 88.8913 328.005C88.8913 327.553 89.2669 327.328 90.018 327.328C90.6787 327.328 91.1615 327.617 91.517 328.182C91.5438 328.226 91.5992 328.241 91.6444 328.218L93.0461 327.509C93.0964 327.484 93.1149 327.42 93.0864 327.372C92.5046 326.363 91.4298 325.811 90.0147 325.811C88.1552 325.811 87 326.727 87 328.184C87 329.732 88.4067 330.123 89.6542 330.393C90.9017 330.663 91.4583 330.769 91.4583 331.249C91.4583 331.729 91.0526 331.956 90.2427 331.956C89.4949 331.956 88.9399 331.613 88.6046 330.949C88.5794 330.9 88.5208 330.88 88.4721 330.905L87.0738 331.598C87.0251 331.623 87.005 331.682 87.0302 331.733C87.5852 332.849 88.7236 333.476 90.2444 333.476C92.181 333.476 93.3513 332.575 93.3513 331.073C93.3513 329.571 91.9378 329.134 90.6921 328.864V328.861Z"/><path d="M98.2036 325.811C97.4088 325.811 96.7063 326.093 96.2017 326.594C96.1698 326.625 96.1178 326.603 96.1178 326.559V323.355C96.1178 323.3 96.0742 323.256 96.0189 323.256H94.2651C94.2097 323.256 94.1662 323.3 94.1662 323.355V333.3C94.1662 333.356 94.2097 333.399 94.2651 333.399H96.0189C96.0742 333.399 96.1178 333.356 96.1178 333.3V328.938C96.1178 328.095 96.7634 327.449 97.6335 327.449C98.5038 327.449 99.1342 328.082 99.1342 328.938V333.3C99.1342 333.356 99.1778 333.399 99.2331 333.399H100.987C101.042 333.399 101.086 333.356 101.086 333.3V328.938C101.086 327.105 99.8854 325.812 98.2036 325.812V325.811Z"/><path d="M104.644 325.525C103.691 325.525 102.799 325.817 102.159 326.239C102.115 326.267 102.1 326.326 102.127 326.371L102.9 327.692C102.929 327.739 102.989 327.756 103.036 327.728C103.522 327.434 104.079 327.281 104.647 327.285C106.178 327.285 107.303 328.365 107.303 329.794C107.303 331.011 106.403 331.912 105.261 331.912C104.33 331.912 103.685 331.37 103.685 330.605C103.685 330.167 103.871 329.807 104.355 329.554C104.406 329.527 104.424 329.465 104.394 329.416L103.665 328.181C103.641 328.141 103.591 328.122 103.545 328.139C102.568 328.501 101.882 329.374 101.882 330.546C101.882 332.318 103.292 333.641 105.259 333.641C107.556 333.641 109.208 332.048 109.208 329.764C109.208 327.315 107.286 325.525 104.644 325.525Z"/><path d="M114.336 325.797C113.449 325.797 112.658 326.125 112.08 326.702C112.048 326.734 111.996 326.71 111.996 326.667V325.972C111.996 325.916 111.952 325.873 111.897 325.873H110.188C110.133 325.873 110.089 325.916 110.089 325.972V335.902C110.089 335.957 110.133 336.001 110.188 336.001H111.942C111.997 336.001 112.041 335.957 112.041 335.902V332.646C112.041 332.602 112.093 332.58 112.125 332.609C112.702 333.146 113.465 333.46 114.338 333.46C116.395 333.46 118 331.793 118 329.628C118 327.462 116.394 325.796 114.338 325.796L114.336 325.797ZM114.006 331.778C112.836 331.778 111.949 330.846 111.949 329.614C111.949 328.382 112.834 327.451 114.006 327.451C115.178 327.451 116.062 328.367 116.062 329.614C116.062 330.861 115.19 331.778 114.004 331.778H114.006Z"/></svg>';
      var tb = s.closest('.kl_reviews__review_item'); tb = tb && tb.querySelector('.kl_reviews__time_badge'); if (tb) { tb.classList.add('sp-rv-time-shop'); tb.appendChild(lab); } else s.parentNode.insertBefore(lab, s);
    });
    var tabs = q('.kl_reviews__list__tab_buttons');
    if (tabs) {
      var cnt = q('.sp-rv-count', tabs);
      if (!cnt) {
        cnt = el('p', 'sp-rv-count');
        cnt.appendChild(el('span', 'sp-rv-count__n'));
        cnt.appendChild(el('span', 'sp-rv-count__sort'));
        tabs.insertBefore(cnt, tabs.firstChild);
      }
      tabs.classList.toggle('sp-rv-single-tab', tabs.querySelectorAll('.kl_reviews__list__tab').length <= 1);
      var total = data.filtered != null ? data.filtered : data.total;
      var nTxt = total != null ? total + (total === 1 ? ' review' : ' reviews') : '';
      var nEl = q('.sp-rv-count__n', cnt);
      var soft = function (e, t) { var had = e.textContent; if (had === t) return; e.textContent = t;
        if (had) { e.classList.remove('sp-rv-num-in'); void e.offsetWidth; e.classList.add('sp-rv-num-in'); } };
      soft(nEl, nTxt);
      var sort = q('.kl_reviews__filters__pill select');
      var sTxt = sort && sort.selectedIndex >= 0 ? 'Sorted by ' + sort.options[sort.selectedIndex].text.toLowerCase() : '';
      var sEl = q('.sp-rv-count__sort', cnt);
      soft(sEl, sTxt);
    }
    var si = q('.kl_reviews__search input');
    if (si) {
      var ph = window.matchMedia('(max-width: 767.98px)').matches ? 'Search' : 'Search reviews';
      if (si.placeholder !== ph) si.placeholder = ph;
    }
    var pills = root.querySelectorAll('.kl_reviews__filters__pill');
    pills.forEach(function (p, i) {
      var s = p.querySelector('select');
      var role = !s ? 'media' : i === 0 ? 'sort' : (s.options[0] && /rating/i.test(s.options[0].text)) ? 'rating' : 'variant';
      setAttr(p, 'data-sp-role', role);
      if (role === 'rating') {
        var opts = [].slice.call(s.options, 1);
        var stars = function (o) { var m = (o.value + ' ' + o.text).match(/\d/); return m ? +m[0] : 0; };
        var want = opts.slice().sort(function (a, b) { return stars(b) - stars(a); });
        if (want.some(function (o, k) { return o !== opts[k]; })) want.forEach(function (o) { s.appendChild(o); });
      }
    });
    var lc = q('.kl_reviews__list_container');
    if (lc && COPY) {
      var side = q('.sp-rv-side', lc);
      if (!side) {
        side = el('aside', 'sp-rv-side');
        side.setAttribute('aria-label', 'About these reviews');
        side.innerHTML = '<div class="sp-rv-topics" hidden><p class="sp-rv-label">Mentioned often</p><div class="sp-rv-chips"></div></div>' +
          '<div class="sp-rv-share"><p class="sp-rv-share__title"></p><p class="sp-rv-share__body"></p>' +
          '<button type="button" class="sp-rv-share__link"><span>Share your pages</span>' + ARROW + '</button></div>';
        q('.sp-rv-share__title', side).textContent = COPY.prompt;
        q('.sp-rv-share__body', side).textContent = COPY.share;
        q('.sp-rv-share__link', side).addEventListener('click', clickWrite);
        lc.appendChild(side);
      }
      var tWrap = q('.sp-rv-topics', side);
      if (data.topics && data.topics.length && !tWrap.dataset.built) {
        var chips = q('.sp-rv-chips', tWrap);
        data.topics.forEach(function (t) {
          var c = el('button', 'sp-rv-chip', t.label);
          c.type = 'button';
          c.dataset.term = t.term;
          c.setAttribute('aria-pressed', 'false');
          c.addEventListener('click', function () { search(c.getAttribute('aria-pressed') === 'true' ? '' : t.term); });
          chips.appendChild(c);
        });
        tWrap.hidden = false;
        tWrap.dataset.built = '1';
      }
      var input = q('.kl_reviews__search input');
      var cur = input ? input.value.trim().toLowerCase() : '';
      side.querySelectorAll('.sp-rv-chip').forEach(function (c) { setAttr(c, 'aria-pressed', c.dataset.term === cur ? 'true' : 'false'); });
    }
    var more = q('.kl_reviews__load_more_button');
    var foot = q('.sp-rv-progress');
    if (more) {
      if (!foot || foot.parentNode !== more) {
        if (foot) foot.remove();
        foot = el('div', 'sp-rv-progress');
        foot.innerHTML = '<p class="sp-rv-progress__text"></p><span class="sp-rv-progress__bar"><span></span></span>';
        more.insertBefore(foot, more.firstChild);
      }
      var shown = [].filter.call(root.querySelectorAll('.kl_reviews__review_item'), function (i) { return i.getClientRects().length; }).length;
      var of = data.filtered != null ? data.filtered : data.total;
      var txt = of ? 'Showing ' + shown + ' of ' + of + ' reviews' : '';
      var pt = q('.sp-rv-progress__text', foot);
      if (pt.textContent !== txt) pt.textContent = txt;
      var pct = of ? Math.min(100, Math.round(shown / of * 1000) / 10) : 0;
      var bar = q('.sp-rv-progress__bar span', foot);
      if (bar.style.width !== pct + '%') bar.style.width = pct + '%';
    }
    root.querySelectorAll('.kl_reviews__review_item').forEach(function (i) {
      i.classList.toggle('sp-rv-unverified', !i.querySelector('.kl_reviews__review__verified'));
    });
  }

  function ensureEmpty(summary) {
    if (q('.sp-rv-emptyp', summary) || !COPY) return;
    var box = el('div', 'sp-rv-emptyp');
    box.innerHTML = '<div class="sp-rv-emptyp__plate"><img src="' + (ctx.dataset.plate || '') + '" alt="" width="1120" height="880" loading="lazy" decoding="async"></div>' +
      '<div class="sp-rv-emptyp__body"><p class="sp-rv-emptyp__eyebrow">No reviews yet</p>' +
      '<h3 class="sp-rv-emptyp__title"></h3><p class="sp-rv-emptyp__text"></p>' +
      '<button type="button" class="sp-rv-write">Write a review</button>' +
      '<p class="sp-rv-label">Not sure where to start?</p><ul class="sp-rv-emptyp__tips"></ul></div>';
    q('.sp-rv-emptyp__title', box).textContent = COPY.title;
    q('.sp-rv-emptyp__text', box).textContent = COPY.empty;
    var ul = q('.sp-rv-emptyp__tips', box);
    COPY.tips.forEach(function (t) { ul.appendChild(el('li', null, t)); });
    q('.sp-rv-write', box).addEventListener('click', clickWrite);
    var h2 = q('.kl_reviews__summary__header', summary);
    summary.insertBefore(box, h2 ? h2.nextSibling : summary.firstChild);
  }

  function search(term) {
    var input = q('.kl_reviews__search input');
    if (!input) return;
    var set = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    set.call(input, term);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    schedule();
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; ensure(); });
  }

  document.documentElement.classList.add('sp-rv26');
  var TALL = { rating_selected: 1, editing: 1, store_review_started: 1 };
  window.addEventListener('message', function (e) {
    if (typeof e.data !== 'string' || !/^https:\/\/reviews(-app\.services)?\.klaviyo\.com$/.test(e.origin)) return;
    document.documentElement.classList.toggle('sp-rv-form-tall', !!TALL[e.data]);
  });

  var host =document.querySelector('[id*="klaviyo_reviews_product_reviews"]');
  if (!host) return;
  function skeletonHandOff() {
    var f = host.querySelector('#fulfilled-reviews-all');
    if (!f || !f.firstElementChild) return false;
    var t0 = performance.now(), last = -1, still = 0;
    (function watch() {
      var h = f.scrollHeight;
      still = h === last ? still + 1 : 0;
      last = h;
      if (still >= 8 || performance.now() - t0 > 900) host.classList.add('sp-rv-sk-done');
      else requestAnimationFrame(watch);
    })();
    return true;
  }
  if (!host.classList.contains('sp-rv-sk-done') && !skeletonHandOff()) {
    var skMo = new MutationObserver(function () { if (skeletonHandOff()) skMo.disconnect(); });
    skMo.observe(host, { childList: true, subtree: true });
  }
  new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
  host.addEventListener('change', schedule);
  host.addEventListener('input', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var fx = { list: null, held: 0, ghost: null, rowSlot: null, rowGhost: null, rowCopy: null, timer: 0, cache: null };
  function liveItem() { return [].find.call(host.querySelectorAll('.kl_reviews__review_item'), function (i) { return !i.closest('.sp-rv-ghost'); }); }
  var EMPTY = '.kl_reviews__list_empty_state__container';
  function itemsBox() { var i = liveItem(); return i ? i.parentElement : host.querySelector(EMPTY); }
  function ours(n) { return n.nodeType === 1 && (n.classList.contains('sp-rv-ghost') || n.classList.contains('sp-rv-rowslot') || !!n.closest('.sp-rv-ghost')); }
  function realRow() { return [].find.call(host.querySelectorAll('.kl_reviews__filter_info'), function (r) { return !r.closest('.sp-rv-rowslot, .sp-rv-ghost'); }) || null; }
  function keepRow() {
    var r = realRow();
    if (fx.held || (r && r.classList.contains('sp-rv-row--wait'))) return;
    fx.rowCopy = r ? r.cloneNode(true) : null;
    if (fx.rowCopy) { fx.rowCopy.classList.remove('sp-rv-row--in', 'sp-rv-row--wait'); fx.rowCopy.removeAttribute('id'); }
  }
  function remember() {
    keepRow();
    var list = host.querySelector('.kl_reviews__list'), box = itemsBox();
    if (!list || !box || fx.ghost) return;
    var br = box.getBoundingClientRect();
    fx.cache = { list: list, h: list.getBoundingClientRect().height, sy: window.scrollY, rect: { top: br.top, left: br.left, width: br.width } };
  }
  function place(g, r) {
    var op = g.offsetParent || g.parentElement, o = op.getBoundingClientRect();
    g.style.top = (r.top - o.top - op.clientTop) + 'px';
    g.style.left = (r.left - o.left - op.clientLeft) + 'px';
    g.style.width = r.width + 'px';
  }
  function hasItem(n) { return n.nodeType === 1 && (n.matches('.kl_reviews__review_item, ' + EMPTY) || !!n.querySelector('.kl_reviews__review_item, ' + EMPTY)); }
  function hold(removed) {
    var c = fx.cache;
    if (!c || !c.list.isConnected) return;
    if (!fx.held) {
      fx.list = c.list; fx.held = c.h;
      c.list.classList.add('sp-rv-busy');
      c.list.style.height = c.h + 'px';
    }
    if (removed && !fx.ghost) {
      var g = el('div', 'sp-rv-ghost');
      g.setAttribute('aria-hidden', 'true');
      removed.forEach(function (n) { g.appendChild(n); });
      c.list.parentElement.appendChild(g);
      var dy = window.scrollY - c.sy;
      place(g, { top: c.rect.top - dy, left: c.rect.left, width: c.rect.width });
      fx.ghost = g;
      if (!REDUCED) { void g.offsetWidth; requestAnimationFrame(function () { g.classList.add('sp-rv-ghost--dim'); }); }
      else g.classList.add('sp-rv-ghost--dim');
    }
    clearTimeout(fx.timer);
    fx.timer = setTimeout(settle, 4000);
  }
  function settle() {
    clearTimeout(fx.timer);
    var list = fx.list, g = fx.ghost;
    fx.list = null; fx.held = 0; fx.ghost = null;
    if (fx.rowSlot) { collapse(fx.rowSlot); fx.rowSlot = null; }
    var rg = fx.rowGhost; fx.rowGhost = null;
    if (rg) { if (REDUCED) rg.remove(); else { rg.classList.add('sp-rv-ghost--out'); setTimeout(function () { rg.remove(); }, 300); } }
    var wr = realRow(); if (wr) wr.classList.remove('sp-rv-row--wait');
    setTimeout(keepRow, 600);
    if (!list) return;
    list.classList.remove('sp-rv-busy');
    if (g) {
      if (REDUCED) g.remove();
      else { g.classList.add('sp-rv-ghost--out'); setTimeout(function () { g.remove(); }, 440); }
    }
    var from = list.getBoundingClientRect().height;
    list.style.height = '';
    var to = list.getBoundingClientRect().height;
    var es = host.querySelector(EMPTY);
    var after = es && es.nextElementSibling;
    if (es && after && !REDUCED && !es.closest('.sp-rv-ghost')) {
      var ec = getComputedStyle(es);
      esH = es.getBoundingClientRect().height + parseFloat(ec.marginTop) + parseFloat(ec.marginBottom);
      after.style.setProperty('--sp-rv-es-from', -esH + 'px');
      es.classList.remove('sp-rv-es-in'); after.classList.remove('sp-rv-es-after');
      void es.offsetWidth;
      es.classList.add('sp-rv-es-in'); after.classList.add('sp-rv-es-after');
    }
    if (REDUCED || Math.abs(to - from) < 2) return;
    list.style.height = from + 'px';
    list.style.overflow = 'clip';
    void list.offsetHeight;
    list.style.transition = 'height 0.56s ' + EASE;
    list.style.height = to + 'px';
    var done = function (e) {
      if (e && e.target !== list) return;
      list.removeEventListener('transitionend', done);
      list.style.height = list.style.transition = list.style.overflow = '';
    };
    list.addEventListener('transitionend', done);
    setTimeout(done, 660);
  }
  var rowH = 0;
  var rowInAt = 0;
  function slotFor() {
    var s = el('div', 'sp-rv-rowslot');
    s.setAttribute('aria-hidden', 'true');
    if (fx.rowCopy && !fx.rowGhost) s.appendChild(fx.rowCopy.cloneNode(true));
    var k = rowInAt ? Math.min(1, (performance.now() - rowInAt) / 360) : 1;
    var now = rowH * (1 - Math.pow(1 - k, 4));
    s.style.height = Math.max(0, now) + 'px';
    if (!REDUCED && Math.abs(now - rowH) > 1) requestAnimationFrame(function () {
      s.style.transition = 'height 0.3s ' + EASE;
      s.style.height = rowH + 'px';
    });
    return s;
  }
  function collapse(s) {
    if (!s.isConnected) return;
    if (REDUCED) { s.remove(); return; }
    var c = s.firstElementChild;
    if (c) { c.style.opacity = getComputedStyle(c).opacity; c.style.transition = 'none'; }
    s.style.height = s.getBoundingClientRect().height + 'px';
    s.style.transition = 'height 0.4s ' + EASE + ', opacity 0.26s ' + EASE;
    void s.offsetHeight;
    s.style.height = '0px';
    s.style.opacity = '0';
    setTimeout(function () { s.remove(); }, 440);
  }
  var quietT = 0;
  function quiet() {
    clearTimeout(quietT);
    quietT = setTimeout(function () {
      if (!fx.held) return;
      if (host.querySelector('[class*="loading"], [class*="spinner"], [class*="skeleton"]')) quiet();
      else settle();
    }, 600);
  }
  var esH = 0;
  function esGone(target) {
    var after = target && target.querySelector('.kl_reviews__list_container');
    if (!after || !esH || REDUCED) return;
    after.style.setProperty('--sp-rv-es-from', esH + 'px');
    after.classList.remove('sp-rv-es-after'); void after.offsetWidth; after.classList.add('sp-rv-es-after');
    esH = 0;
  }
  function rowOverlay(at, copy) {
    var list = fx.list || (fx.cache && fx.cache.list);
    if (fx.rowGhost || !list || !list.isConnected) return;
    var sr = at.getBoundingClientRect(), op0 = getComputedStyle(at).opacity;
    var og = el('div', 'sp-rv-ghost sp-rv-rowghost');
    og.setAttribute('aria-hidden', 'true');
    og.style.opacity = op0;
    og.appendChild(copy);
    list.parentElement.appendChild(og);
    place(og, sr);
    void og.offsetWidth;
    requestAnimationFrame(function () { og.style.opacity = ''; og.classList.add('sp-rv-ghost--dim'); });
    fx.rowGhost = og;
  }
  var lastRow = null;
  new MutationObserver(function (records) {
    var removedItems = [], itemsAdded = false;
    records.forEach(function (r) {
      if (r.target.nodeType === 1 && r.target.closest('.sp-rv-ghost')) return;
      [].forEach.call(r.removedNodes, function (n) {
        if (ours(n)) return;
        if (hasItem(n)) removedItems.push(n);
        if (n.nodeType === 1 && n.matches(EMPTY) && r.target.isConnected) esGone(r.target);
        if (n.nodeType === 1 && lastRow && (n === lastRow || n.contains(lastRow)) && r.target.isConnected) {
          var s = fx.rowSlot = fx.rowSlot || slotFor();
          r.target.insertBefore(s, r.nextSibling && r.nextSibling.parentNode === r.target ? r.nextSibling : null);
        }
      });
      [].forEach.call(r.addedNodes, function (n) { if (!ours(n) && n.nodeType === 1 && (n.matches('.kl_reviews__review_item') || n.querySelector('.kl_reviews__review_item'))) itemsAdded = true; });
    });
    var row = realRow();
    var rowNew = row && row !== lastRow;
    if (row && !rowNew && fx.rowCopy && !REDUCED && (fx.held || (fx.cache && fx.cache.list.isConnected)) && !row.classList.contains('sp-rv-row--wait') &&
        records.some(function (r) { return row.contains(r.target); }) &&
        row.textContent.replace(/\s+/g, '') !== fx.rowCopy.textContent.replace(/\s+/g, '')) {
      rowOverlay(row, fx.rowCopy.cloneNode(true));
      row.classList.add('sp-rv-row--wait');
      hold(null);
    }
    if (rowNew) {
      if (fx.rowSlot) {
        var sl = fx.rowSlot; fx.rowSlot = null;
        if (sl.firstChild && fx.held) rowOverlay(sl.firstChild, sl.firstChild);
        sl.remove();
      }
      else {
        var rc = getComputedStyle(row);
        rowH = row.getBoundingClientRect().height + parseFloat(rc.marginTop) + parseFloat(rc.marginBottom);
        if (!REDUCED) {
          row.style.setProperty('--sp-rv-row-h', rowH + 'px');
          row.style.setProperty('--sp-rv-row-mb', rc.marginBottom);
          row.classList.add('sp-rv-row--in');
          rowInAt = performance.now();
        }
      }
    }
    if (row) lastRow = row;
    if (removedItems.length && !liveItem()) hold(removedItems);
    else if (removedItems.length || rowNew) hold(null);
    if (rowNew && fx.held && !REDUCED) row.classList.add('sp-rv-row--wait');
    if (fx.held) {
      if (itemsAdded) requestAnimationFrame(function () { requestAnimationFrame(settle); });
      else quiet();
    }
    if (!fx.held) remember();
  }).observe(host, { childList: true, subtree: true, characterData: true });
  host.addEventListener('pointerdown', remember, true);
  host.addEventListener('keydown', remember, true);

  var started = false;
  function start() { if (!started) { started = true; load(); } }
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (e) { if (e.some(function (x) { return x.isIntersecting; })) { io.disconnect(); start(); } }, { rootMargin: '800px 0px' });
    io.observe(host);
  } else start();
  schedule();
})();
